import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
//import styles from "styles.module.css";
import i18n from "../../../i18n";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";

let t = i18n.t;

export const AnnualStatementGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "year",
			title: "År",
			width: "60px",
		},
		{
			field: "customerBusinessRegisterNumber",
			title: t("OrgNumber"),
			width: "200px",
			className: `no-border`,
		},
		{
			field: "customerName",
			title: t("VesselName"),
			//width: "150px",
			headerClassName: "no-border",
		},
		{
			field: "vesselOwnerName",
			title: t("VesselOwner"),
			//width: "150px",
			headerClassName: "no-border",
		},
	];
	return gridItems;
};

export const AnnualStatementFrontGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "year",
			title: "År",
			width: "60px",
		},
		{
			field: "year",
			title: "År",
			width: "60px",
		},
		{
			field: "customerBusinessRegisterNumber",
			title: t("OrgNumber"),
			width: "200px",
			className: `no-border`,
		},
		{
			field: "customerName",
			title: t("VesselName"),
			//width: "150px",
			headerClassName: "no-border",
		},
		{
			field: "vesselOwnerName",
			title: t("VesselOwner"),
			//width: "150px",
			headerClassName: "no-border",
		},
	];
	return gridItems;
};
